import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

export const SectionHeading = ({
  left,
  right,
}: {
  left: string;
  right?: string;
}) => (
  <Stack
    className="w-full"
    direction="row"
    align="baseline"
    justify="between"
    gap={4}
  >
    <Text variant="title" className="min-w-0 truncate" title={left}>
      {left}
    </Text>
    {right && (
      <Text variant="caption" tone="muted" className="shrink-0">
        {right}
      </Text>
    )}
  </Stack>
);
